import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { QRCodeCanvas } from "qrcode.react";
import gpalogo from "../../assets/gpa-logo.jpg";
const RegistrationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state ?? {};
  
  
  const eventDate = "March 02, 2025"; // Example event date
  const eventTime = "08:00 AM - 05:00 PM"; // Example event time

  const generatePDF = () => {
    const doc = new jsPDF();
    
    doc.setFillColor(41, 128, 185); // Blue header
  doc.rect(0, 0, 210, 30, "F");

  // 🔹 Add Logo (Right Side)

  doc.addImage(gpalogo, "PNG", 170, 50, 25, 30); // X = 170 (right side), Y = 5, Width = 30, Height = 20

  // 🔹 Title on Left Side
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.text("Registration Confirmation", 15, 20);

    // Ticket Details
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(14);
    doc.text(`Name: ${formData.name}`, 15, 50);
    doc.text(`Email: ${formData.email}`, 15, 60);
    doc.text(`Event: GPACON 2025`, 15, 70);
    doc.text(`Registration ID: ${formData.registrationID}`, 15, 80);
    doc.text(`Registration Type ${formData.role}`, 15, 90);
    doc.text(`Date: ${eventDate}`, 15, 100);
    doc.text(`Time: ${eventTime}`, 15, 110);

    // Add Table
    doc.autoTable({
      startY: 140,
      head: [["Field", "Details"]],
      body: [
        [" Name", formData.name],
        ["Email", formData.email],
        ["Event", "GPACON 2025"],
        ["Registration Id", formData.registrationID],
        ["Registration Type", formData.role],
        ["Date", eventDate],
        ["Time", eventTime],
      ],
      theme: "striped",
      headStyles: { fillColor: [41, 128, 185] },
    });
    doc.setFontSize(10);
  doc.setTextColor(150); // Light gray color
  doc.text(" GENERAL PRACTITIONER’SASSOCIATION OF ICHALKARANJI", 105, doc.internal.pageSize.height - 10, { align: "center" });

    // Save PDF
    doc.save("Ticket_Confirmation.pdf");
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Confirmed!</h1>
      <p style={styles.message}>
        Your registration for <strong>GPACON 2025</strong> is Successful!
      </p>

      <div style={styles.ticket}>
        <div style={styles.ticketHeader}>
          <h2>🎟 Registration Details</h2>
        </div>

        <div style={styles.ticketBody}>
          <p><strong>Name:</strong> {formData.name}</p>
          <p><strong>Email:</strong> {formData.email}</p>
          <p><strong>Event:</strong> GPACON 2025</p>
          <p><strong>Registration ID:</strong> {formData.registrationID}</p>
          <p><strong>Registration Type:</strong> {formData.role}</p>
          <p><strong>Event Date:</strong> {eventDate}</p>
          <p><strong>Time:</strong> {eventTime}</p>
          
          {/* <div style={styles.qrContainer}>
            <QRCodeCanvas value={`Registration ID: ${formData.registrationID}`} size={100} />
            <p style={styles.qrText}>Scan for Ticket Details</p>
          </div> */}
        </div>
      </div>

      <button style={styles.pdfButton} onClick={generatePDF}>
        📥 Download 
      </button>
      <button style={styles.continueButton} onClick={() => navigate("/")}>
        ⬅️ Back to Home
      </button>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f4f4f4",
    minHeight: "100vh",
  },
  title: {
    color: "#2980b9",
    fontSize: "24px",
    fontWeight: "bold",
  },
  message: {
    fontSize: "16px",
    color: "#555",
  },
  ticket: {
    backgroundColor: "white",
    width: "80%",
    maxWidth: "500px",
    margin: "20px auto",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  },
  ticketHeader: {
    backgroundColor: "#2980b9",
    color: "white",
    padding: "10px",
    borderRadius: "8px 8px 0 0",
    textAlign: "center",
  },
  ticketBody: {
    padding: "15px",
    textAlign: "left",
    fontSize: "16px",
  },
  qrContainer: {
    textAlign: "center",
    marginTop: "10px",
  },
  qrText: {
    fontSize: "12px",
    color: "#888",
  },
  pdfButton: {
    backgroundColor: "#27ae60",
    color: "white",
    padding: "10px 15px",
    border: "none",
    borderRadius: "5px",
    margin: "10px",
    cursor: "pointer",
  },
  continueButton: {
    backgroundColor: "#e74c3c",
    color: "white",
    padding: "10px 15px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default RegistrationSuccess;
